export default function (context) {
  // Add the middlewareUserUrl property in the context (available in `asyncData` and `fetch`)
  context.middlewareUserUrl = process.server
    ? context.req.headers.host + context.route.path
    : window.location.hostname + window.location.pathname
}
